import Box from "./Box";
import BoxWithGutter from "./BoxWithGutter";
import DashHeading from "./DashHeading";
import Image from "./Image";
import IndentedParagraphMedium from "./IndentedParagraphMedium";
import PropTypes from "prop-types";
import { RESPONSIVE } from "../core/constants";
import React from "react";
import Text from "./Text";
import getConfig from "../core/config";

function AboutIntro({
  mainHeading,
  subheading,
  text,
  imageDesktop,
  imageMobile,
}) {
  return (
    <Box bg="lightBlue" pt={[100, null, 120, null]}>
      <BoxWithGutter pb={["15vw", "6.66vw", null, null]}>
        <Text
          as="h1"
          uppercase
          fontSize={[26, 26, 62, 62]}
          lineHeight={["32px", "32px", 1, 1]}
          dangerouslySetInnerHTML={{ __html: mainHeading }}
        />
        <Box mt={[38, null, 60, null]}>
          <DashHeading heading={subheading} />
          <Box
            mt={[30, null, 60, null]}
            maxWidth={[null, "80vw", null, null]}
            mx="auto"
          >
            <IndentedParagraphMedium>{text}</IndentedParagraphMedium>
          </Box>
        </Box>
      </BoxWithGutter>
      <Box pr={[15, "4.76vw", null, null]} mb={["-40%", "-15.2%", null, null]}>
        <Box maxWidth={[null, "80vw", null, null]}>
          <Box
            height={0}
            pb={["80vw", "38%", null, null]}
            position="relative"
            maxWidth={[null, "80vw", null, null]}
          >
            <Image
              src={imageDesktop.url}
              alt={imageDesktop.title}
              height="100%"
              width="100%"
              position="absolute"
              top={0}
              left={0}
              objectFit="cover"
              objectPosition="50% 0%"
              display={["none", "initial", null, null]}
              bg="lightGrey"
            />
            <Image
              src={imageMobile.url}
              alt={imageMobile.title}
              height="100%"
              width="100%"
              position="absolute"
              top={0}
              left={0}
              objectFit="cover"
              objectPosition="50% 0%"
              display={["initial", "none", null, null]}
              bg="lightGrey"
            />
            <Image
              src="/images/Speech-Bubble.svg"
              alt="No more clothes in landfill"
              position="absolute"
              width={["42vw", "20vw", null, null]}
              height="auto"
              top={["-20%", null, "-6vw", null]}
              right={[-15, null, "-13.7vw", null]}
              layout={RESPONSIVE}
              imgHeight={288}
              imgWidth={333}
            />
          </Box>
        </Box>
      </Box>
    </Box>
  );
}

export default AboutIntro;

AboutIntro.propTypes = {
  mainHeading: PropTypes.string.isRequired,
  subheading: PropTypes.string.isRequired,
  text: PropTypes.string.isRequired,
  imageDesktop: PropTypes.shape({
    url: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired,
  }).isRequired,
  imageMobile: PropTypes.shape({
    url: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired,
  }).isRequired,
};
